import { useMemo } from 'react';

import { GatewayRuleFieldChip } from 'pages/GatewayRules/components/GatewayRuleField/GatewayRuleFieldChip';
import { useGatewayRuleConditions } from 'pages/GatewayRules/context/GatewayRuleConditionsContext';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';

type Props = {
  codes: string[];
};

export function GatewayRuleFieldExpressionParamCurrency({ codes }: Props): JSX.Element {
  const { currenciesByCode } = useGatewayRuleConditions();
  const currenciesValue = useMemo(
    () => codes?.map((code) => currenciesByCode.get(code)?.name).join(', '),
    [currenciesByCode, codes],
  );

  if (!currenciesByCode.size) {
    return <></>;
  }

  return (
    <Tooltip
      placement="bottom-start"
      title={<Typography fontSize={11}>{currenciesValue}</Typography>}
    >
      <GatewayRuleFieldChip label={currenciesValue} />
    </Tooltip>
  );
}
